var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorite1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.3166 22.8894C74.1243 14.6971 60.841 14.6971 52.6474 22.8894C51.6384 23.8984 50.7602 24.9869 49.9987 26.1317C49.2384 24.9881 48.3589 23.8984 47.3499 22.8894C39.1576 14.6971 25.8743 14.6971 17.6807 22.8894C9.48713 31.0817 9.48713 44.3651 17.6807 52.5587L49.9999 84.8753L82.3166 52.5587C90.5102 44.3651 90.5102 31.0817 82.3166 22.8894Z",
    stroke: "#34749C",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite1);
export default __webpack_public_path__ + "static/media/favorite-1.f394f4a3e58d88f47430fd53691b6d6f.svg";
export { ForwardRef as ReactComponent };